import { CheckSquare, Undo2, XCircle } from "lucide-react"
import { Button } from "shared/ui/button"
import { Card, CardContent } from "shared/ui/card"
import { Checkbox } from "shared/ui/checkbox"

interface PermitApprovalsBulkActionsProps {
  isAllSelected: boolean
  selectedCount: number
  selectableCount: number
  canMassApprove: boolean
  canApproveSelection: boolean
  canMassCancelOrRevise: boolean
  onToggleSelectAll: (checked: boolean) => void
  onMassCancel: () => void
  onMassApprove: () => void
  onMassRevise: () => void
}

export function PermitApprovalsBulkActions({
  isAllSelected,
  selectedCount,
  selectableCount,
  canMassApprove,
  canApproveSelection,
  canMassCancelOrRevise,
  onToggleSelectAll,
  onMassCancel,
  onMassApprove,
  onMassRevise,
}: PermitApprovalsBulkActionsProps) {
  const massApproveDisabled = selectedCount === 0 || !canApproveSelection

  return (
    <Card className="border-slate-200 shadow-sm">
      <CardContent className="flex flex-col gap-3 p-4 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-3 text-sm text-slate-600">
          <Checkbox
            className="h-5 w-5"
            checked={isAllSelected}
            disabled={selectableCount === 0}
            onCheckedChange={(checked) => onToggleSelectAll(checked === true)}
          />
          <span>เลือกทั้งหมด ({selectedCount}/{selectableCount})</span>
        </div>
        <div className="flex flex-col items-end gap-1">
          <div className="flex gap-2">
            {canMassCancelOrRevise ? (
              <Button
                variant="outline"
                className="border-amber-200 text-amber-700 hover:bg-amber-50 hover:text-amber-800"
                disabled={selectedCount === 0}
                onClick={onMassRevise}
              >
                <Undo2 className="mr-2 h-4 w-4" />
                ส่งกลับแก้ไข ({selectedCount})
              </Button>
            ) : null}
            {canMassCancelOrRevise ? (
              <Button
                variant="outline"
                className="border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700"
                disabled={selectedCount === 0}
                onClick={onMassCancel}
              >
                <XCircle className="mr-2 h-4 w-4" />
                ยกเลิกรายการ ({selectedCount})
              </Button>
            ) : null}
            {canMassApprove ? (
              <Button
                className="bg-emerald-600 text-white hover:bg-emerald-700"
                disabled={massApproveDisabled}
                onClick={onMassApprove}
                title={selectedCount > 0 && !canApproveSelection ? "Mass Approve ใช้ได้เฉพาะรายการ Hot Work Permit เท่านั้น" : undefined}
              >
                <CheckSquare className="mr-2 h-4 w-4" />
                อนุมัติ ({selectedCount})
              </Button>
            ) : null}
          </div>
          {canMassApprove && selectedCount > 0 && !canApproveSelection ? (
            <span className="text-xs text-amber-600">Mass Approve ใช้ได้เฉพาะรายการ Hot Work Permit เท่านั้น</span>
          ) : null}
        </div>
      </CardContent>
    </Card>
  )
}
